export const paths = {
  projects: '/',
  contacts: '/contacts',
  career: '/career',
  development: '/development',
  team: '/team',
  languages: '/languages',
  price: '/price',
  terms: '/terms',
  widget: '/widget',
  notFound: '/404'
}
